<template lang="pug">
  #calendarDiv
    FullCalendar#fullcalendar(ref="calendarDiv", :options="calendarOptions")
</template>
<script>
import $ from 'jquery'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

// import Hammer from 'hammerjs'
import moment from 'moment'
import Noty from '@/components/shared/Notify'

import modalsBus from '@/components/shared/ModalsBus'
import _ from 'lodash'

import {mapGetters} from 'vuex'
import Vue from 'vue'

import MousetrapManager from '@/components/shared/mousetrapManager'

export default {
  props: {
    view: {
      type: String,
      required: true
    },
    eventsBus: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentHeight: $(window).height() - 80,
      calendarOptions: {
        plugins: [ dayGridPlugin, interactionPlugin, timeGridPlugin ],
        initialView: this.fullCalendarView,
        editable: true,
        // eventLimit: true,
        selectable: true,
        // selectHelper: true,
        longPressDelay: 200,
        eventLongPressDelay: 200,
        nowIndicator: true,
        themeSystem: 'bootstrap',
        buttonText: {
          today: this._i18n.t('globals.moments.today')
        },
        headerToolbar: {
          start: 'today',
          center: 'title',
          end: 'prev,next'
        },
        snapDuration: '00:10:00',
        scrollTime: moment().format('HH:00:00'),
        aspectRatio: 3,
        height: this.currentHeight,
        windowResize: () => {
          this.calendarOptions.height = $(window).height() - 80
        },
        locale: this.$i18n.locale,
        firstDay: 1,
        fixedWeekCount: false,
        views: {
          timeGridOneDay: {
            type: 'timeGrid',
            duration: { days: 1 }
          }
        },
        eventDisplay: 'block',
        eventClick: ({event, jsEvent, view}) => {
          modalsBus.open(modalsBus.modals.OPEN_SHARED_OBJECT, event.extendedProps._data)
        },
        select: function ({start, end, jsEvent, view}) {
          var mstart = moment(start)
          var mend = moment(end)
          if (view.type === 'dayGridMonth') {
            mstart.add(moment().local().hours(), 'hours')
            mend.subtract(1, 'day').add(moment().local().hours() + 1, 'hours')
          }
          modalsBus.open(modalsBus.modals.CREATE_EVENT, {start: mstart.local(), end: mend.local()})
        },
        eventDrop: this.resizeOrDrop,
        eventResize: this.resizeOrDrop,
        eventDidMount: ({el, event, view}) => {
          var element = el
          var answer, regex, text, _i, _len, _ref
          if ((event.extendedProps._data == null) || event.extendedProps._data.kind !== 'event') {
            return true
          }
          $(element).css('background-color', event.extendedProps._data.group.color)
          $(element).css('border-color', event.extendedProps._data.group.color)
          answer = event.extendedProps._data.answers[this.user.id]
          let testAnswer = (() => {
            let answers = this.searchKeyedValues('answers')
            if (answers.length > 0) {
              if (answers.indexOf('none') > -1) {
                if (answer.answer == null) {
                  return true
                }
              }
              if (answers.indexOf('yes') > -1) {
                if (answer.answer === 'Yes') {
                  return true
                }
              }
              if (answers.indexOf('no') > -1) {
                if (answer.answer === 'No') {
                  return true
                }
              }
              if (answers.indexOf('maybe') > -1) {
                if (answer.answer === 'Maybe') {
                  return true
                }
              }
              return false
            }
            return true
          })()
          if (!testAnswer) {
            return $(element).hide()
          }
          if (this.searchObject.texts.length > 0) {
            _ref = this.searchObject.texts
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              text = _ref[_i]
              regex = new RegExp('.*' + _.escapeRegExp(text) + '.*', 'i')
              if (regex.test(event.extendedProps._data.city) || regex.test(event.extendedProps._data.country) || regex.test(event.extendedProps._data.name) || regex.test(event.extendedProps._data.description) || regex.test(event.extendedProps._data.type)) {
                return $(element).show()
              }
            }
            return $(element).hide()
          } else {
            return $(element).show()
          }
        },
        eventSources: [
          {
            events: (fetchInfo, callback, failureCallback) => {
              var start = fetchInfo.start
              var end = fetchInfo.end
              let notification = Noty.info(this._i18n.t('globals.loading'))
              this.$store.dispatch('events/load', {
                start: moment(start).unix(),
                end: moment(end).unix(),
                groops: this.selectedGroops
              }).then((events) => {
                notification.close()
                let fullcalendarEvents = []
                events.forEach((event) => {
                  var allDay, endTime, startTime
                  startTime = moment.unix(event.startTime)
                  endTime = moment.unix(event.endTime)
                  allDay = startTime.format('HHmm') === '0000' && (endTime.format('HHmm') === '0000' || endTime.format('HHmm') === '2359')
                  if (allDay && endTime.format('HHmm') === '2359') {
                    endTime.add(1, 'm')
                  }

                  fullcalendarEvents.push({
                    id: event.id,
                    title: event.name,
                    start: startTime.format(),
                    end: endTime.format(),
                    allDay: allDay,
                    color: event.color,
                    _data: event,
                    className: this.classesForEvent(event)
                  })
                })
                callback(fullcalendarEvents)
              }).catch((err) => {
                notification.close()
                failureCallback(err)
              })
            }
          }
        ]
      }
    }
  },
  components: {
    FullCalendar
  },
  mounted () {
    $(window).on('focus.eventsCalendar', () => {
      this.reinitView() // to refresh today where window is active
    })
    this.installCalendar()
    this.eventsBus.$on(this.eventsBus.NEW_EVENT, (data) => {
      this.refetchEvents()
    })
    this.eventsBus.$on(this.eventsBus.NEW_EVENTS, (data) => {
      this.refetchEvents()
    })
    this.eventsBus.$on(this.eventsBus.UPDATED_EVENT, (data) => {
      this.refetchEvents()
    })
    this.eventsBus.$on(this.eventsBus.DELETED_EVENT, (data) => {
      this.refetchEvents()
    })
    this.eventsBus.$on(this.eventsBus.UPDATED_GROUP_COLOR, (data) => {
      this.recolorEvents(data.group)
    })
    MousetrapManager.bindAll({
      'j': () => {
        this.$refs.calendarDiv.getApi().prev()
      },
      'k': () => {
        this.$refs.calendarDiv.getApi().next()
      }}, 'Events-Calendar')
  },
  destroyed () {
    $(window).off('focus.eventsCalendar')
    modalsBus.closeAll()
    MousetrapManager.unbindLabel('Events-Calendar')
  },
  computed: {
    ...mapGetters('groops', [
      'selectedGroops'
    ]),
    ...mapGetters('user', [
      'user'
    ]),
    ...mapGetters('search', [
      'searchObject',
      'searchKeyedValues'
    ]),
    fullCalendarView () {
      let views = {
        month: 'dayGridMonth',
        week: 'timeGridWeek',
        day: 'timeGridOneDay'
      }
      return views[this.view] || views['dayGridMonth']
    }
  },
  methods: {
    updateView () {
      this.$refs.calendarDiv.getApi().changeView(this.fullCalendarView)
    },
    reinitView () {
      this.$refs.calendarDiv.getApi().render()
    },
    installCalendar () {
      this.$nextTick(() => {
        this.calendarOptions.windowResize()
        this.updateView()
        // let hammertime = new Hammer(this.$refs.calendarDiv)
        // hammertime.on('swipeleft', () => {
        //   try {
        //     document.createEvent('TouchEvent')
        //     // $(this.$refs.calendarDiv).fullCalendar('next')
        //   } catch (e) {
        //     // not touch screen => no swipe
        //   }
        // })
        // hammertime.on('swiperight', () => {
        //   try {
        //     document.createEvent('TouchEvent')
        //     // $(this.$refs.calendarDiv).fullCalendar('prev')
        //   } catch (e) {
        //     // not touch screen => no swipe
        //   }
        // })
      })
    },
    refetchEvents () {
      this.$refs.calendarDiv.getApi().refetchEvents()
    },
    rerenderEvents () {
      this.$refs.calendarDiv.getApi().refetchEvents()
    },
    recolorEvents (group) {
      // _.each($(this.$refs.calendarDiv).fullCalendar('clientEvents'), (e) => {
      //   if (e._data.group.id === group.id) {
      //     e._data.group.color = group.color
      //   }
      // })
      this.rerenderEvents()
    },
    resizeOrDrop ({event, delta, revert}) {
      this.$store.dispatch('events/putEvent', {
        id: event.extendedProps._data.id,
        startTime: moment(event.start).local().unix(),
        endTime: moment(event.end).local().unix()
      })
      .then((response) => {
        new Noty({
          text: Vue.i18n.t('events.notify.moved'),
          type: 'success'
        }).show()
      })
      .catch(() => {
        new Noty({
          text: Vue.i18n.t('globals.error'),
          type: 'error',
          timeout: 5000
        }).show()
        revert()
      })
    },
    needOwnAnswer (event) {
      return (moment.unix(event.endTime).isAfter(moment()) &&
        (!event.answers[this.user.id || this.user.name] || !event.answers[this.user.id || this.user.name].answer)) &&
        event.groupAnswer !== 'No' &&
        event.status !== 'REFUSED'
    },
    inPast (event) {
      return moment.unix(event.endTime).isBefore(moment())
    },
    isRefused (event) {
      return (event.answers[this.user.id || this.user.name] && event.answers[this.user.id || this.user.name].answer === 'No') ||
        event.groupAnswer === 'No' ||
        event.status === 'REFUSED'
    },
    classesForEvent (event) {
      let classes = []
      let group = this.$store.getters['groops/getGroupWithId'](event.group.id)

      if (this.needOwnAnswer(event) && (!group || group.expectAnswer === null || group.expectAnswer === true)) {
        classes.push('needOwnAnswer')
      }
      if (this.inPast(event)) {
        classes.push('inPast')
      }
      if (this.isRefused(event)) {
        classes.push('refused')
      }
      return classes
    }
  },
  watch: {
    view () {
      this.updateView()
    },
    selectedGroops () {
      this.refetchEvents()
    },
    searchObject () {
      this.rerenderEvents()
    }
  }
}
</script>
<style>
#fullcalendar .fc-view-harness{
  background-color: white !important;  
}
#fullcalendar .fc-toolbar-chunk {
  zoom: 0.8;
  margin: 5px !important;
}
</style>



// WEBPACK FOOTER //
// Events-Calendar.vue?4be58218